import React, { useState } from 'react'
import useStore from '../../../StorePeople/Store'
import ExpandedRecords from '../../ExpandedRecords/ExpandedRecordsPeople'
import { useMutation, useQueryCache } from 'react-query'
import { postPeople } from '../../../../Api/index'
import expandedRecordIcon from './images/expandedSVG.svg'
import styles from './styles.module.css'

function Results () {
  const { dataResults, isQueryLoading } = useStore()
  const dataRecords = dataResults?.data?.records
  const [isModalOpen, setModalOpen] = useState(false)
  const [errorNotEnoughCredits, setErrorNotEnoughCredits] = useState(false)
  const [snackBarStateError, setSnackBarStateError] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [isLoadingRecord, setLoadingRecord] = useState(false)
  const queryCache = useQueryCache()

  const [mutate] = useMutation(postPeople, {
    onSuccess: data => {
      const newRecord = data?.data?.records[0]
      if (newRecord) {
        const cacheKey = `recordByID-${newRecord.id}`
        queryCache.setQueryData(cacheKey, newRecord)
        setSelectedRecord(newRecord)
        setModalOpen(true)
        setLoadingRecord(false)
      }
    },
    onError: () => {
      // show error snackbar immediately
      setSnackBarStateError(true)
      // after 1s, flip the "no credits" flag & stop spinner
      setTimeout(() => {
        setErrorNotEnoughCredits(true)
        setLoadingRecord(false)
      }, 1000)
    }
  })

  const handleRecordClick = record => {
    const cacheKey = `recordByID-${record.id}`
    const cachedData = queryCache.getQueryData(cacheKey)

    setModalOpen(true)
    setSelectedRecord(cachedData || null)
    setLoadingRecord(!cachedData)

    if (!cachedData && !isQueryLoading) {
      mutate({ query: `keys:"${record?.keys[0]}"` })
    } else if (cachedData) {
      setLoadingRecord(false)
    }
  }

  return (
    <section className={styles.searchResultsContainerWithScroll}>
      {dataRecords?.map((record, index) => (
        <div
          onClick={() => handleRecordClick(record)}
          key={index}
          className={styles.searchResultsContainer}
          style={{
            opacity: isQueryLoading ? 0.5 : 1,
            cursor: isQueryLoading ? 'not-allowed' : 'pointer'
          }}
        >
          <div className={styles.expandedRecordPeopleContainer}>
            <div className={styles.expandedRecordPeopleName}>
              <span className={styles.expandedRecordPeopleNameText}>
                {record.firstName
                  ? `${record.firstName} ${record.lastName || ''}`.trim()
                  : 'N/A'}
              </span>
            </div>
            <div>
              <img
                className={styles.expandedRecordPeopleIcon}
                src={expandedRecordIcon}
                alt='ExpandIcon'
              />
            </div>
          </div>

          <div className={styles.expandedRecordPeopleDetails}>
            <div className={styles.listingItem} style={{ width: '150px' }}>
              <span className={styles.expandedRecordPeopleDetail}>Title</span>
              <span className={styles.expandedRecordPeopleValue}>
                {record.jobTitle ? `${record.jobTitle}` : 'N/A'}
              </span>
            </div>
            <div className={styles.listingItem} style={{ width: '100px' }}>
              <span className={styles.expandedRecordPeopleDetail}>Company</span>
              <span className={styles.expandedRecordPeopleValue}>
                {record.businessName ? record.businessName : 'N/A'}
              </span>
            </div>
            <div className={styles.listingItem} style={{ width: '100px' }}>
              <span className={styles.expandedRecordPeopleDetail}>Address</span>
              <span className={styles.expandedRecordPeopleValue}>
                {record.address ? record.address : 'N/A'}
              </span>
            </div>
            <div className={styles.listingItem} style={{ width: '75px' }}>
              <span className={styles.expandedRecordPeopleDetail}>City</span>
              <span className={styles.expandedRecordPeopleValue}>
                {record.city ? record.city : 'N/A'}
              </span>
            </div>
            <div className={styles.listingItem} style={{ width: '75px' }}>
              <span className={styles.expandedRecordPeopleDetail}>
                Province
              </span>
              <span className={styles.expandedRecordPeopleValue}>
                {record.province ? record.province : 'N/A'}
              </span>
            </div>
            <div className={styles.listingItem} style={{ width: '75px' }}>
              <span className={styles.expandedRecordPeopleDetail}>
                Postal code
              </span>
              <span className={styles.expandedRecordPeopleValue}>
                {record.postalCode ? record.postalCode : 'N/A'}
              </span>
            </div>
            <div className={styles.listingItem} style={{ width: '150px' }}>
              <span className={styles.expandedRecordPeopleDetail}>
                Email(s)
              </span>
              <span className={styles.expandedRecordPeopleValue}>
                {record.emails ? (
                  <>
                    {record.emails[0].slice(
                      0,
                      record.emails[0].indexOf('@') + 1
                    )}
                    <span className={styles.moreEmails}>
                      {' '}
                      (+{record.emails.length - 1} more)
                    </span>
                  </>
                ) : (
                  'N/A'
                )}
              </span>
            </div>
            <div className={styles.listingItem} style={{ width: '175px' }}>
              <span className={styles.expandedRecordPeopleDetail}>
                Phone(s)
              </span>
              <span className={styles.expandedRecordPeopleValue}>
                {record.phones && record.phones.length > 0 ? (
                  <>
                    {record.phones[0]}
                    <span className={styles.morePhones}>
                      {' '}
                      (+{record.phones.length - 1} more)
                    </span>
                  </>
                ) : record.phoneNumbers && record.phoneNumbers.length > 0 ? (
                  <>
                    {record.phoneNumbers[0].number}
                    <span className={styles.morePhones}>
                      {' '}
                      (+{record.phoneNumbers.length - 1} more)
                    </span>
                  </>
                ) : (
                  'N/A'
                )}
              </span>
            </div>
          </div>
          <div
            className={styles.listingItem}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <span className={styles.expandedRecordPeopleFieldsAvailable}>
              {dataResults?.data?.records?.length} fields available
            </span>
          </div>
        </div>
      ))}

      {isModalOpen && (
        // <ExpandedRecords
        //   recordData={selectedRecord}
        //   isLoadingRecord={isLoadingRecord} // Pass the loading state
        //   onClose={() => {
        //     setModalOpen(false)
        //   }}
        // />
        <ExpandedRecords
          recordData={selectedRecord}
          isLoadingRecord={isLoadingRecord}
          errorNotEnoughCredits={errorNotEnoughCredits}
          setErrorNotEnoughCredits={setErrorNotEnoughCredits}
          snackBarStateError={snackBarStateError}
          onClose={() => setModalOpen(false)}
        />
      )}
    </section>
  )
}

export default Results
